import { Link, useLocation, useNavigate } from "react-router-dom";

// Estilos
import styles from './breadcrumbs.module.css';

// Assets
import { IoIosArrowBack } from "react-icons/io";

// Constantes
import breadcrumbLabels from '../../constants/breadcrumbLabels';

function Breadcrumbs({ currentLabel = null, idLabels = [] }) {
  const location = useLocation();
  const navigate = useNavigate();

  // --- NOVO: detectar se está em /home (robusto a barra final) ---
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isHome = normalizedPath === "/home";
  // ---------------------------------------------------------------

  const pathnames = location.pathname.split("/").filter(Boolean);
  const allSegments = [...pathnames];

  const sortedIdLabels = [...idLabels].sort((a, b) => (a.place || 0) - (b.place || 0));
  const usedIdCounts = {};

  const getLabelData = (segment, isLast /* , index */) => {
    if (isLast && currentLabel) {
      return { label: currentLabel, clickable: false };
    }

    const sameIdLabels = sortedIdLabels.filter(item => item.id === segment);
    if (sameIdLabels.length > 0) {
      const takeIndex = usedIdCounts[segment] || 0;
      const match = sameIdLabels[Math.min(takeIndex, sameIdLabels.length - 1)];
      usedIdCounts[segment] = takeIndex + 1;
      return { label: match.label, clickable: false };
    }

    const entry = breadcrumbLabels[segment];
    if (entry && typeof entry === 'object') {
      return { label: entry.label, clickable: entry.clickable !== false };
    }

    return { label: decodeURIComponent(segment), clickable: true };
  };

  return (
    <div className={styles.wrapperWithBack}>
      {!isHome && (
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          <IoIosArrowBack /> Voltar
        </button>
      )}

      <nav className={styles.breadcrumbWrapper}>
        <div className={styles.breadcrumbContainer}>
          <Link to="/" className={`${styles.breadcrumbItem} ${styles.home}`}>
            <span className={styles.link}>Início</span>
          </Link>

          {!isHome && (
            <>
              {allSegments.map((segment, index) => {
                const isLast = index === allSegments.length - 1;
                const { label, clickable } = getLabelData(segment, isLast);

                const styleClass = index % 2 === 0 ? styles.alt1 : styles.alt2;
                const path = "/" + allSegments.slice(0, index + 1).join("/");
                const finalClickable = !isLast && clickable;

                return (
                  <span
                    key={path + segment + index}
                    className={`${styles.breadcrumbItem} ${styleClass} ${!finalClickable ? styles.notClickable : ''}`}
                  >
                    {finalClickable ? (
                      <Link to={path} className={styles.link}>{label}</Link>
                    ) : (
                      <span className={styles.current}>{label}</span>
                    )}
                  </span>
                );
              })}
            </>
          )}
          
        </div>
      </nav>
    </div>
  );
}

export default Breadcrumbs;